<ng-container >
    <app-registration-form [portalRegistrationPageData]="portalRegistrationPageData"/>
    <app-registration-title [isLoading]="isLoading" [portalRegistrationPageData]="portalRegistrationPageData"/>
</ng-container>